import { __read } from "tslib";
export var getSelectors = function (_a) {
    var groupMode = _a.groupMode, keys = _a.keys, disabledKeys = _a.disabledKeys, colors = _a.colors, selector = _a.selector;
    if (groupMode === 'stacked') {
        var dataSelector = selector.selector;
        var _b = __read(dataSelector, 1), index_1 = _b[0];
        var selectors_1 = [];
        keys.forEach(function (key, idx) {
            if (!disabledKeys.includes(key)) {
                selectors_1.push({
                    selector: [index_1, key],
                    color: colors[idx],
                });
            }
        });
        return selectors_1;
    }
    return [selector];
};
